import { Box, makeStyles, Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';

interface OwnProps {
  textColor?:
    | 'inherit'
    | 'initial'
    | 'primary'
    | 'secondary'
    | 'textPrimary'
    | 'textSecondary'
    | 'error';
  iconColor?: 'inherit' | 'primary' | 'secondary' | 'error' | 'disabled' | 'action';
}

const NoData: React.FC<OwnProps> = ({ textColor = 'primary', iconColor = 'primary' }) => {
  const classes = useStyles();

  return (
    <Box className={classes.noDataBlock}>
      <ErrorOutlineIcon color={iconColor ?? 'inherit'} />
      <Typography color={textColor ?? 'inherit'}> No data</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  noDataBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
  },
}));

export default NoData;
